// components/AchievementProgressBar.jsx
import React from "react";
import PropTypes from "prop-types";
import styles from "./AchievementProgressBar.module.scss";
import AchievementProgressBarSVG from "./AchievementProgressBarSVG.jsx";

const AchievementProgressBar = ({ countAll = 10, count = 0 }) => {
  // console.log(countAll, count);

  const progressPosition = Math.round(count * (countAll / 100) * 100);
  // console.log(progressPosition);

  return (
    <div className={styles.progressBarContainer}>
      <AchievementProgressBarSVG offset={progressPosition} />
    </div>
  );
};

AchievementProgressBar.propTypes = {
  countAll: PropTypes.number,
  count: PropTypes.number,
};

export default AchievementProgressBar;
